var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTicketlab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 445 59.5",
    enableBackground: "new 0 0 445 59.5",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4C7F88",
    d: "M190.2,3.9H232v10.9h-28.1V24h25.7v10.6h-25.7v10h28.9v11.7h-42.5V3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C7F88",
    d: "M285.6,15.7h-15.6v40.7h-13.7V15.7h-15.6V3.9h44.9V15.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C7F88",
    d: "M184.5,56.4h-16.7l-17.3-24.5v24.5h-13.7V3.9h13.7v23.5l16.4-23.5h14.8l-16.9,24.5L184.5,56.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#99B6BB",
    d: "M294.1,3.9h13.7v40.7h24.4v11.7h-38.1V3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#99B6BB",
    d: "M396.6,3.9h24.5c9-0.1,18.9,2.2,18.9,13.1c0,4.7-2.8,8.5-6.9,10.6c5.6,1.6,9,6.5,9,12.4    c0,12.5-9.2,16.3-20.4,16.3h-25.2V3.9z M410.3,24.6h10.6c2.3,0,5.6-1.2,5.6-5c0-3.8-2.7-5.1-5.6-5.1h-10.6V24.6z M410.3,45.4h10.9    c4.3,0,7.3-1.5,7.3-5.9c0-4.6-3.2-6.2-7.3-6.2h-10.9V45.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#99B6BB",
    points: "371.3,23.4 371.3,3.9 357.5,3.9 357.5,23.4 337.9,56.3 390.9,56.3   "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#004855",
    d: "M46.8,15.7H31.1v40.7H17.5V15.7H1.8V3.9h44.9V15.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004855",
    d: "M114.7,22.7c-0.7-5.3-4.8-8.1-10.6-8.1c-8.8,0-12.2,7.8-12.2,15.6c0,7.8,3.4,15.6,12.2,15.6    c6.4,0,10.1-3.7,10.6-9.7h13.7c-0.7,13.5-10.6,21.4-23.9,21.4c-15.9,0-26.1-12.1-26.1-27.3c0-15.2,10.3-27.3,26.1-27.3    c11.3,0,23.6,7.2,23.9,19.8H114.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#004855",
    d: "M69.8,4v52.4H56.1V4H69.8z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketlab);
export default __webpack_public_path__ + "static/media/ticketlab.6c3aec34ba3e1d4c3dcc0fdb0c18271a.svg";
export { ForwardRef as ReactComponent };